import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { API_OPTIONS } from '../utilities/constants';
import { addTrailerVideo } from '../utilities/movieSlice';

// fetched trailer video for a movie using the TMDB API and dispatches it to the Redux store

const useMovieTrailer=(movieId)=>{

 const dispatch=useDispatch();

  useEffect(() => {
    const getMovieVideo=async ()=>{
      try {
        const data=await fetch('https://api.themoviedb.org/3/movie/'+movieId+
          '/videos?language=en-US', API_OPTIONS)
        const json=await data.json();
        const filterData=json.results.filter(video => video.type === 'Trailer');
        const trailer=filterData.length?filterData[1]:json.results[0];
        dispatch(addTrailerVideo(trailer));
      } catch (e) {
        console.warn('TMDB trailer fetch failed, falling back to YouTube search', e);
        dispatch(addTrailerVideo(null));
      }
    }
    getMovieVideo();
  }, [movieId, dispatch]);
}

export default useMovieTrailer;